import type { Page } from '../../types';
import { REPORTING_PERIOD } from './shared_variables';

const externalByDefault: Page[] = [
  {
    pageType: 'question',
    title: 'External by default',
    name: 'external-by-default-page',
    hidePageTitle: true,
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      {
        questionType: 'textarea',
        title:
          'Please confirm whether external by default SCS recruitment has been adopted in your department.',
        hint: 'If external by default has been adopted, please also confirm the date of implementation and whether this has been applied to certain grades only.',
        name: 'external-by-default-policy',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'externalExemptionInput',
        title: 'External exemption',
        name: 'external-exemption-input',
        hint: `If External by Default has been implemented in your department, please confirm the number of Ministerial exemptions granted to advertise SCS vacancies across the Civil Service only between ${REPORTING_PERIOD}`,
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default externalByDefault;
